import { callFunction } from '@/commands/callFunction'

/**
 * Actions métier portant sur l'état de jeu d'une équipe.
 * Les scores globaux et l'irréversibilité des relances sont arbitrés côté serveur.
 */
export default {
  /** Administration : force les scores d'attractivité RH et commerciale d'une équipe. */
  updateScores(periodId, teamId, { hr, attractivity } = {}) {
    return callFunction('updateStateScores', { periodId, teamId, hr, attractivity })
  },

  /** Administration : met à jour les paramètres du monde (coefficients, finance, rôles). */
  updateApplicationParameters(parameters) {
    return callFunction('updateApplicationParameters', { parameters })
  },

  /** Bascule vers une autre application My First Business. */
  switchCurrentApplication(applicationId) {
    return callFunction('switchCurrentApplication', { applicationId })
  },

  /** Envoie une relance de paiement pour une facture client. */
  requestInvoicePayment(periodId, teamId, invoiceId) {
    return callFunction('requestInvoicePayment', { periodId, teamId, invoiceId })
  },
}
